import { createId } from "../../app/runtimeContext";

export type MemoryType =
  | "company"
  | "project"
  | "product"
  | "conversation"
  | "decision"
  | "task"
  | "architecture";
export type MemoryStatus = "active" | "superseded" | "archived";

export type MemoryEntry = {
  id: string;
  type: MemoryType;
  title: string;
  summary: string;
  details: string;
  source: string;
  created: string;
  updated: string;
  owner: string;
  confidence: number;
  tags: string[];
  references: string[];
  status: MemoryStatus;
};

export class MemoryEngine {
  private readonly entries = new Map<string, MemoryEntry>();

  save(input: Omit<MemoryEntry, "id" | "created" | "updated">): MemoryEntry {
    const now = new Date().toISOString();
    const entry: MemoryEntry = {
      ...input,
      id: createId("memory"),
      created: now,
      updated: now,
    };
    this.entries.set(entry.id, entry);
    return entry;
  }

  list(type?: MemoryType): MemoryEntry[] {
    return [...this.entries.values()].filter(
      (entry) => !type || entry.type === type,
    );
  }
}
